var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 55.1309,
    width: 69.0141,
    height: 1.7536,
    fill: "#EABC6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3577 14H22.3983C22.1789 14 21.9983 14.157 21.9983 14.3403V26.6024V28.2774C21.9983 28.6569 22.3596 28.971 22.8111 28.971H45.9448C46.3964 28.971 46.7577 28.6569 46.7577 28.2774V26.6024V14.3403C46.7577 14.157 46.5771 14 46.3577 14Z",
    fill: "#C6E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.3853 28.8787C22.5143 28.9441 22.6562 28.9834 22.811 28.9834H45.9447C46.3963 28.9834 46.7576 28.6693 46.7576 28.2898V26.6147V25.1621C39.4162 27.2167 31.1588 28.5123 22.3853 28.8787Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8746 31.85H31.7524L32.3072 19.915C32.3072 19.7973 32.4234 19.7188 32.5653 19.7188H35.8554C35.9973 19.7188 36.1134 19.8104 36.1134 19.915L36.8746 31.85Z",
    fill: "#291482"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0356 32.3077C38.0356 32.3469 37.9969 32.3731 37.9582 32.3731H30.4104C30.3717 32.3731 30.333 32.3469 30.333 32.3077V32.0721C30.333 31.9543 30.4491 31.8496 30.5911 31.8496H37.7776C37.9195 31.8496 38.0356 31.9412 38.0356 32.0721V32.3077Z",
    fill: "#291482"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.1497,
    y: 34.3066,
    width: 63.2984,
    height: 1.9499,
    transform: "rotate(-180 66.1497 34.3066)",
    fill: "#B5C5F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3887 41.8353V49.3601V56.8849H46.3965V49.3601V41.8353V34.3105H63.3887V41.8353Z",
    fill: "#7A6DEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6046 34.3105V41.8353V49.3601V56.8849H5.6123V49.3601V41.8353V34.3105H22.6046Z",
    fill: "#7A6DEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3965,
    y: 48.6777,
    width: 23.7917,
    height: 14.369,
    transform: "rotate(-180 46.3965 48.6777)",
    fill: "#ACA2FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.3887,
    y: 34.9531,
    width: 57.7891,
    height: 0.654328,
    transform: "rotate(-180 63.3887 34.9531)",
    fill: "#616FB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAddressIcon);
export default __webpack_public_path__ + "static/media/office-address-icon.b56b95896b104b2a8362b251e913b8fb.svg";
export { ForwardRef as ReactComponent };